import styled from 'styled-components';

export const DiceValueWrapper = styled.div`
    position: relative;
`;

export const DiceValue = styled.div.attrs((props)=>({
    style: {
        width: (()=>{
            let w=1,a=props.sides; 
            while(1 <= (a = a/10)){w++} 
            return 15 + w*10;
        })() + 'px'
    }
}))`
    font-size: 18px;
    width: 45px;
    text-align: center;
    font-weight: 900;
    color: #fff;
    position: relative;

    &.critical {
        color: #0a0;
    }

    &.fail {
        color: #f33;
    }

    &.ignored {
        color: #555;
    }

    :before {
        content: '+';
        width: 6px;
        font-size: 14px;
        color: #aaa;
        text-align: center;
        position: absolute;
        top: calc(50% - 10px);
        left: -3px;
        height: 20px;
        line-height: 20px;
    }

    ${DiceValueWrapper}:first-child & {
        padding-left: 0;
    }

    &.fateDice:before,
    ${DiceValueWrapper}:first-child &:before {
        content: '';
    }
`;

export const DiceValueEffect = styled.div`
        position: absolute;
        opacity: 0;
        top: 50%;
        left: 50%;
        font-size: 18px;
        width: 40px;
        text-align: center;
        font-weight: 900;
        color: #fff;
        transform-origin: 50% 50%;
        transform: translate3d(-50%, -50%, 0) scale(1);

        &.shown {
            animation: diceEffect 1s ease forwards;
        }

        &.hidden {
            display: none;
        }
    
        &.critical {
            color: #0a0;
        }
    
        &.fail {
            color: #f33;
        }
`;